import React, { useState, useEffect } from "react";
import axios from "axios";
import ClosePage from "./EventsPageComponents/Closed";
import CompletedPage from "./EventsPageComponents/Completed";
import UpcomingPage from "./EventsPageComponents/Upcoming";
import InterestedPage from "./EventsPageComponents/Interested";
import ConfirmetPage from "./EventsPageComponents/Confirmet";
import EventsPage from "../Event/Event";
import AddEventPage from "../Modals/Event/AddEvent";
const TabNavigation = () => {
  const [events, setEvents] = useState([]);
  const [activeTab, setActiveTab] = useState("Upcoming");
  const [showAddEventPopup, setShowAddEventPopup] = useState(false);
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const handleAddEventClick = () => {
    setShowAddEventPopup(true);
  };
    useEffect(() => {
      fetchEvents();
    }, []);
    const fetchEvents = async () => {
      try {
        const response = await axios.get("/events/get_all", {
          params: {
            user_type: sessionStorage.getItem("profession_id"),
            lom_id: sessionStorage.getItem("lom"),
          },
        });
        setEvents(response.data);
      } catch (error) {
        console.error("Error fetching LOM Presidents:", error);
      }
    };


  // Render the corresponding page based on the active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case "UpComing":
        return <UpcomingPage />;
      case "interested":
        return <InterestedPage />;
      case "confirmet":
        return <ConfirmetPage />;
      case "close":
        return <ClosePage />;
      case "completed":
        return <CompletedPage />;
      case "all":
        return <EventsPage />;
      default:
        return <UpcomingPage />;
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        {/* Heading and description */}
      
        <div className="mb-6">
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-white">
            Events
          </h1>
          <h6 className="text-sm font-bold text-[#b6b7ba] dark:text-[#b6b7ba] mt-2">
            See your scheduled events from your calendar.
          </h6>  <div className="mb-2 flex justify-end pr-36">
            <button
              onClick={handleAddEventClick}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Add Event
            </button>
          </div>

        </div>
      

        {/* Navigation container with background and no underline */}
        <div className="flex flex-wrap justify-center sm:justify-start">
          <ul className="flex flex-wrap justify-center text-sm font-bold text-center text-[#a2a2a4] dark:text-[#a2a2a4] bg-[#f8f8f8] dark:bg-[#2d3748] rounded-lg mb-4">
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("UpComing")}
                className={`inline-block px-4 py-3 rounded-lg ml-2 ${
                  activeTab === "UpComing"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
                aria-current={activeTab === "UpComing" ? "page" : undefined}
              >
                UpComing
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("interested")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "interested"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Interested
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("confirmet")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "confirmet"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Confirmed
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("close")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "close"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Close
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("completed")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "completed"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Completed
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("all")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "all"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                All
              </a>
            </li>
          </ul>
        </div>
        {showAddEventPopup && (
            <AddEventPage
              onClose={() => setShowAddEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}
        {/* Render the corresponding page content */}
        <div className="mt-4 p-4">{renderTabContent()}</div>
      </div>
    </div>
  );
};

export default TabNavigation;
